/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="filters.module.ts" />

module Meevo.Components.Filters {

    type CurrencySymbolPositionType = 'right' | 'left';
    interface IMeevoCurrencyArguments {
        format?: string;
        currencySymbol?: string;
        decimalPositions?: number;
        currencySymbolPosition?: CurrencySymbolPositionType;
    }

    export function meevoCurrencyFilter($filter: angular.IFilterService, identityService: Meevo.Components.Common.IIdentityService, $locale: angular.ILocaleService): any {

        const filter = (input: any, format?: string | IMeevoCurrencyArguments, currencySymbol?: string, decimalPositions?: number, currencySymbolPosition: CurrencySymbolPositionType = 'left') => {
            if(format && typeof format === 'object') {
                currencySymbol = format.currencySymbol;
                decimalPositions = format.decimalPositions;
                currencySymbolPosition = format.currencySymbolPosition || 'left';
                format = format.format;
            }

            let identity = identityService.current();
            let amount = Number(input);

            if (!isNaN(amount)) {
                let decimalPositionsFinal = decimalPositions || identity.decimalPositions || 2;
                let currencySymbolFinal = currencySymbol || $locale.NUMBER_FORMATS.CURRENCY_SYM;

                let currencyFilter = $filter('currency') as angular.IFilterCurrency;

                let getAmount = (amount) => {
                    let result = currencyFilter(amount, currencySymbolFinal, decimalPositionsFinal);
                    if (decimalPositionsFinal === 1) {
                        result += '0';
                    }
                    if(currencySymbolPosition === 'right') {
                        result = result.slice(1) + result.slice(0, 1);
                    }

                    return result;
                };

                switch (format) {
                    case 'financial':
                        return amount < 0
                            ? '(' + getAmount(Math.abs(amount)) + ')'
                            : getAmount(amount);
                    default:
                        return getAmount(amount);
                }
            }


            return input;
        };


        return filter;
    }

    meevoCurrencyFilter.$inject = ['$filter', 'meevo.components.common.IdentityService', '$locale'];

    angular.module('meevo.components.filters')
        .filter('meevoCurrency', meevoCurrencyFilter);
}
